module.exports.dewPoint = require('./lib/dewPoint');
module.exports.humidex = require('./lib/humidex');
module.exports.vaporPressure = require('./lib/vaporPressure');
module.exports.windChill = require('./lib/windChill');